import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, { ...appConfig, providers: [...appConfig.providers] }).catch(err =>
  // eslint-disable-next-line no-console
  console.error(err),
);
